import {A11y, Controller, EffectCreative, Navigation} from 'swiper/modules';
import Swiper from "swiper";

export function imageTextSlider(query = document.querySelectorAll('.imageTextSlider')) {
    for (let imageTextSlider of query) {
        const gallerySliderElement = imageTextSlider.querySelector(".js-gallery-slider");
        const textSliderElement = imageTextSlider.querySelector(".js-content-slider");
        Swiper.use([Navigation, Controller, EffectCreative, A11y]);
        const textSlider = new Swiper(textSliderElement, {
            a11y: true,
            loop: true,
            allowTouchMove: false
        });
        const gallerySlider = new Swiper(gallerySliderElement, {
            controller: {
                control: textSlider
            },
            a11y: true,
            effect: "creative",
            loop: true,
            creativeEffect: {
                prev: {
                    translate: [0, 0, -1],
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
            navigation: {
                nextEl: gallerySliderElement.querySelector(".swiper-button-next"),
                prevEl: gallerySliderElement.querySelector(".swiper-button-prev")
            }
        });

    }
}

